import { useState } from 'react'
import { Togglable } from '../Togglable'
import { useRef } from 'react'
import styles from './BlogForm.module.css'
import Card from '../Card'

export const BlogForm = ({ addBlog }) => {
  const [newBlog, setNewBlog] = useState({
    title: '',
    author: '',
    url: '',
  })

  const blogFormRef = useRef()

  const handleSave = e => {
    const blogObject = {
      title: newBlog.title,
      author: newBlog.author,
      url: newBlog.url,
    }

    e.preventDefault()
    blogFormRef.current.toggleVisibility()
    addBlog(blogObject)
    setNewBlog({
      title: '',
      author: '',
      url: '',
    })
  }

  const handleInputChange = e => {
    const newValue = e.target.value

    if (e.target.name === 'title') {
      setNewBlog({
        title: newValue,
        author: newBlog.author,
        url: newBlog.url,
      })
    } else if (e.target.name === 'author') {
      setNewBlog({
        title: newBlog.title,
        author: newValue,
        url: newBlog.url,
      })
    } else if (e.target.name === 'url') {
      setNewBlog({
        title: newBlog.title,
        author: newBlog.author,
        url: newValue,
      })
    }
  }

  return (
    <Card variant="empty">
      <Togglable label="New Blog" ref={blogFormRef}>
        <form className={[styles.form].join(' ')}>
          <input
            id="newBlogTitleInput"
            data-testid="titleInput"
            name="title"
            value={newBlog.title}
            onChange={handleInputChange}
            placeholder="title"
          />

          <input
            id="newBlogAuthorInput"
            data-testid="authorInput"
            name="author"
            value={newBlog.author}
            onChange={handleInputChange}
            placeholder="author"
          />
          <input
            id="newBlogURLInput"
            data-testid="urlInput"
            name="url"
            value={newBlog.url}
            onChange={handleInputChange}
            placeholder="www..."
          />
          <button
            id="newBlogSubmitButton"
            data-testid="newBlogSubmitButton"
            onClick={handleSave}
            className="btn-accent-dark"
            type="submit"
          >
            save
          </button>
        </form>
      </Togglable>
    </Card>
  )
}

export default BlogForm
